import { GridCellSelectionModel, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { TableFilterInput } from '~/common/generated/apollo-operations'
import { DossGridFilterModel } from '~/components/tables/filters'
import { DetailedChildTable } from '~/components/tables/types'
import { DossTable, TableSource } from '../DossTable'

interface StandaloneDossTableProps {
  childTable: DetailedChildTable
  handleMergedCellSelectionModel: (model: GridCellSelectionModel) => void
  mergedCellSelectionModel: GridCellSelectionModel
  row: GridRenderCellParams['row']
  readOnly: boolean
  backlinkColumnId?: string
  tableFilters?: TableFilterInput[] | null
  gridFilterModel?: DossGridFilterModel | null
  showBorderBottom?: boolean
  showBorderTop?: boolean
}

/**
 * Returns the doss table for a child table
 */
export function StandaloneDossTable({
  mergedCellSelectionModel,
  childTable,
  row,
  readOnly,
  handleMergedCellSelectionModel,
  backlinkColumnId,
  tableFilters,
  showBorderTop,
  showBorderBottom,
  gridFilterModel,
}: StandaloneDossTableProps) {
  return (
    <DossTable
      backlinkColumnId={backlinkColumnId}
      cellSelectionModel={mergedCellSelectionModel}
      className="flex-1"
      gridFilterModel={gridFilterModel}
      handleCellSelectionModelChange={handleMergedCellSelectionModel}
      parentRowId={row.id}
      readOnly={readOnly}
      selectedTabId={childTable.tableTabs.at(0)?.id}
      showBorderBottom={showBorderBottom}
      showBorderTop={showBorderTop}
      showEmptyState
      showPadding
      table={{
        ...childTable,
        // Child table filters need to be for columns on the child table. We cannot filter
        // chidl tables by columns on the parent table.
        tableTabs: childTable.tableTabs.map((tab) => ({
          ...tab,
          filters: tab.filters
            .filter(
              (
                filter,
              ): filter is typeof filter & {
                tableColumn: NonNullable<typeof filter.tableColumn>
              } => filter.tableColumn != null,
            )
            .map((filter) => ({
              ...filter,
              tableColumn: { ...filter.tableColumn, table: childTable },
            })),
        })),
        childTables: [],
        lookupBacklinkTables: [],
        charts: [],
        parentTable: childTable.parentTable
          ? { ...childTable.parentTable, name: '', icon: null, columns: [] }
          : null,
        organization: {
          __typename: 'Organization' as const,
          id: '',
        },
      }}
      tableFilters={tableFilters}
      tableId={childTable.id}
      tableSource={TableSource.CHILD_IN_TABLE_DETAIL}
    />
  )
}
